import {gql} from '@apollo/client';

export const uploadMutations = {
    UPLOAD_ITEM_DATA_FOR_BOARD: gql`
        mutation uploadItemDataForBoard(
            $file: Upload!
            $itemFieldsFormat: [ItemDataOwnedFieldsInput!]!
            $statusId: UUID!
            $uniqueField: String!
            $sprintId: UUID
        ) {
            uploadItemDataForBoard(
                file: $file
                itemFieldsFormat: $itemFieldsFormat
                statusId: $statusId
                uniqueField: $uniqueField
                sprintId: $sprintId
            ) {
                statusCode
                message
                success
                data
            }
        }
    `,
};
